import { Link } from "@reach/router";
import React from "react";
import Logo from "../assets/images/ttc-logo.svg";
import { t } from "../lang";
import styled from "styled-components";


const Thankyou = (props: any) => {
  return (
    <div className="App">
      <header className="App-header" style={{ background:"#182a33"}}>
      
          <LogoImage src={Logo} alt="logo" />
          <Title>{t('Thank You')}</Title>
        


        <Link to="/">
        <Button>الرئيسية</Button>
        </Link>
      </header>
    </div>
  );
};


const Button = styled.div`

background-color:#008AAB;
padding:10px 30px;`

const LogoImage = styled.img`


width:400px;`

const Title = styled.h1`
font-size: 2em;
width: 360px;
text-align: center;
position: relative;
::before {
  border-top: 23px solid rgb(209 255 158);
  content: "";
  position: absolute;
  inset: 37px 0px 0px;
  width: 81%;
  z-index: -1;
}
`
export default Thankyou;
